export default {"src":"/_next/static/media/price-drop.2726ea02.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};